import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Stack,
  Backdrop,
  CircularProgress,
  Autocomplete,
  Dialog,
  DialogContent,
  Fab,
  Divider,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar, SnackbarProvider } from "notistack";
import { BACKEND_URL, NIMBLE_AUTH_API } from "../../helpers/variables";
import { ArrowForward, Clear } from "@mui/icons-material";

function Login() {
  const navigate = useNavigate();

  const [clients, setClients] = useState()
  const [corporations, setCorporations] = useState([]);

  const [auth, setAuth] = useState();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [client, setClient] = useState(null);
  const [corporation, setCorporation] = useState(null);

  const [loading, setLoading] = useState(false);

  const clientURL = client?.url

  useEffect(() => {
    fetchClients()
  }, [])

  async function fetchClients() {
    let res = await fetch(`${BACKEND_URL}/client_list`)
    setClients(await res.json())
  }

  const handleLogin = async () => {
    if (!clientURL || !email || !password) {
      alert("Please fill all fields");
      return;
    }

    setLoading(true);
    let res = await fetch(`${NIMBLE_AUTH_API}/${client.user_management_version}/OpenApiauth/Login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userName: email,
        password: password,
        url: clientURL.split(".")[0],
      }),
    });
    setLoading(false);

    let data = await res.json();

    if (data["statusCode"] !== 200) {
      enqueueSnackbar(data["status"], { variant: "error" });
      return;
    }

    setAuth(data);

    // ----------------------------------
    setLoading(true);
    res = await fetch(`${BACKEND_URL}/corporation_list?client_url=${clientURL}`);
    setLoading(false);
    if (!res.ok) {
      enqueueSnackbar(await res.text(), { variant: "error" });
      return;
    }

    setCorporations(await res.json());
  };

  return (
    <SnackbarProvider>
      <Stack height={"100%"} alignItems={"center"} justifyContent={"center"}>
        <Stack width={400} gap={2} alignItems={"center"}>
          <Typography variant="h5" textAlign="center">
            Login
          </Typography>

          <TextField
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
          />

          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
          />

          <Autocomplete
            fullWidth
            options={clients || []}
            loading={!clients}
            value={client}
            getOptionLabel={(o) => o.url}
            onChange={(_, v) => setClient(v)}
            renderInput={(params) => <TextField {...params} label="Client" />}
          />

          <Button
            variant="contained"
            color="primary"
            onClick={handleLogin}
            fullWidth
          >
            Login
          </Button>
        </Stack>
      </Stack>

      <Dialog
        open={Boolean(auth)}
        onClose={() => setAuth(null)}
        fullWidth
        maxWidth="xs"
      >
        <Box>
          <IconButton onClick={() => setAuth(null)}>
            <Clear />
          </IconButton>
        </Box>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Autocomplete
            options={corporations}
            value={corporation}
            onChange={(e, v) => setCorporation(v)}
            getOptionLabel={(option) => option.Name}
            getOptionKey={(option) => option.corporationID}
            renderInput={(params) => (
              <TextField {...params} label="Corporation" />
            )}
            fullWidth
            blurOnSelect
          />

          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              navigate(
                `/inbox?client_url=${clientURL}&corporation_id=${corporation["corporationID"]}&nimbleAuthID=${auth.authID}`,
              )
            }
            disabled={!corporation}
            sx={{ my: 2 }}
          >
            Redirect
          </Button>
        </DialogContent>
      </Dialog>

      <Backdrop open={loading}>
        <CircularProgress />
      </Backdrop>
    </SnackbarProvider>
  );
}

export default Login;
